module.exports = {"653223001":"街道","653223100":"固玛镇","653223101":"杜瓦镇","653223102":"赛图拉镇","653223103":"木吉镇","653223104":"阔什塔格镇","653223105":"桑株镇","653223201":"克里阳乡","653223202":"科克铁热克乡","653223205":"乔达乡","653223206":"木奎拉乡","653223207":"藏桂乡","653223208":"皮亚勒玛乡","653223209":"皮西那乡","653223210":"巴什兰干乡","653223211":"垴阿巴提塔吉克民族乡","653223212":"康克尔柯尔克孜民族乡","653223401":"皮山三峡工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653223.json
// module id = 3262
// module chunks = 0